import React from "react";
import { SetAuth } from "Helpers/AuthToken";
import { useGoogleLogin } from "@react-oauth/google";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuthStore } from "Store/AuthStore";

type Inputs = {
  username: string;
  email: string;
  password: string;
};

const Register = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const googleSignIn = useAuthStore((state) => state.googleSignIn);
  const registerUser = useAuthStore((state) => state.register);

  const googleRegister = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const response = await googleSignIn(tokenResponse.access_token);

        SetAuth(`${response.Token}`);
        window.location.href = "/germinationTrays";
      } catch (error) {
        console.error("Google sign-in failed", error);
      }
    },
    onError: (error) => {
      console.error("Google login failed", error);
    },
  });

  const registerAccount = async (
    username: string,
    email: string,
    password: string,
  ) => {
    const data = await registerUser(email, username, password);

    if (data?.accessToken) {
      SetAuth(data.accessToken);
      window.location.href = "/germinationTrays";
    }
  };

  const onSubmit = async (data: any) => {
    if (data.username && data.email && data.password) {
      await registerAccount(data.username, data.email, data.password);
    }
  };

  return (
    <div className="flex min-h-screen flex-1 flex-col justify-center px-6 py-5 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm lg:mb-[35px]">
        <img
          className="mx-auto h-[250px] w-[250px]"
          src="logo.png"
          alt="Bloomscape Logo"
        />
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Register a new account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900 text-left"
            >
              Username
            </label>

            <div className="mt-2">
              <input
                id="username"
                type="username"
                autoComplete="username"
                className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                {...register("username", {
                  required: true,
                  pattern: /^[a-zA-Z0-9]+([_ -]?[a-zA-Z0-9])*$/,
                })}
              />
              {errors.username && errors.username.type === "required" && (
                <span className="text-red text-sm">Username is required</span>
              )}
              {errors.username && errors.username.type === "pattern" && (
                <span className="text-red text-sm">
                  Username cannot contain special characters
                </span>
              )}
            </div>
          </div>
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900 text-left"
            >
              Email
            </label>

            <div className="mt-2">
              <input
                id="email"
                type="email"
                autoComplete="email"
                className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                {...register("email", {
                  required: true,
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                })}
              />
              {errors.email && errors.email.type === "required" && (
                <span className="text-red text-sm">Email is required</span>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <span className="text-red text-sm">
                  Please enter a valid email address
                </span>
              )}
            </div>
          </div>
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium leading-6 text-gray-900 text-left"
            >
              Password
            </label>
            <div className="mt-2">
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                {...register("password", {
                  required: true,
                  pattern:
                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{10,}$/,
                })}
              />
              {errors.password && errors.password.type === "required" && (
                <span className="text-red text-sm">Password is required</span>
              )}
              {errors.password && errors.password.type === "pattern" && (
                <span className="text-red text-sm">
                  Password must be at least 10 characters long and include
                  uppercase, lowercase, number, and special character
                </span>
              )}
            </div>
          </div>

          <div>
            <button
              type="submit"
              title="Submit"
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white btn-green shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Register
            </button>
            <button
              className="flex items-center justify-center gap-2 mx-auto my-5"
              onClick={() => googleRegister()}
            >
              <img
                className="w-10 h-10"
                src="googleicon.svg"
                alt="Google Icon"
              />{" "}
              <p> Sign in with Google</p>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Register;
